import { Map } from 'immutable';

import { EMPTY } from '../../../constants';

export function shapeAiOperationsForApp({ operations }) {
  function reduceOperations(aiState, { destination_field: destination, input: { instructions = '' }, operation }) {
    return aiState.set(destination, Map({ instructions, operation }));
  }

  return operations.reduce(reduceOperations, EMPTY.MAP);
}

export function shapeAiOperationsForAPI({ state }) {
  function reduceAttributes(operations, value, destination) {
    if (!value.get('operation')) return operations;

    const operation = {
      destination_field: destination,
      input: {},
      operation: value.get('operation'),
    };

    if (value.get('instructions')) {
      operation.input.instructions = value.get('instructions');
    }

    operations.push(operation);

    return operations;
  }

  return state.reduce(reduceAttributes, []);
}
